import { createHttpLink, ApolloLink } from '@apollo/client'

const httpLink = (apiURI: string): ApolloLink =>
  createHttpLink({
    uri: ({ operationName }) => {
      // in the dev tools network tab, show the name of the query/mutation being made instead of just 'graphql'
      // for example, the network tab would show 'graphql?CurrentUserContext_CurrentUser' instead of 'graphql'
      const uri = `${apiURI}/graphql?${operationName}`

      return uri
    },
    credentials: 'include',
  })

export default httpLink
